import { blinkConstants } from '@thoughtspot/blink-constants';
import { FontFaceFormat, FontFaceStyle, } from '@thoughtspot/custom-style-service';
import { requestAssetUrl } from './asset-resolver.util';
export function convertFontFaceStyleToString(fontFaceStyle) {
    switch (fontFaceStyle) {
        case FontFaceStyle.ITALIC:
            return 'italic';
        case FontFaceStyle.OBLIQUE:
            return 'oblique';
        default:
            return 'normal';
    }
}
export function convertFontFormatToString(fontFormat) {
    switch (fontFormat) {
        case FontFaceFormat.WOFF2:
            return 'WOFF2';
        default:
            return 'WOFF';
    }
}
export function convertFontWeightToString(fontWeight) {
    return fontWeight?.toString() || '';
}
export function convertSizeToString(fontSize) {
    return fontSize?.toString() || '';
}
export const getNumOfColorPalette = () => {
    return Object.keys(blinkConstants.defaultColorPalette).length;
};
export const getAllFontFaces = async (customFontFaces) => {
    const defaultFontFaces = [
        {
            guid: null,
            family: 'Optimo-Plain',
            format: 'opentype',
            color: 'black',
            weight: '400',
            style: 'normal',
            size: '14',
            url: 'font/optimo/Plain-Light.otf',
        },
        {
            guid: null,
            family: 'Optimo-Plain',
            format: 'opentype',
            color: 'black',
            weight: '400',
            style: 'italic',
            size: '14',
            url: 'font/optimo/Plain-LightIta.otf',
        },
        {
            guid: null,
            family: 'Optimo-Plain',
            format: 'opentype',
            color: 'black',
            weight: '600',
            style: 'normal',
            size: '14',
            url: 'font/optimo/Plain-Regular.otf',
        },
        {
            guid: null,
            family: 'Optimo-Plain',
            format: 'opentype',
            color: 'black',
            weight: '600',
            style: 'italic',
            size: '14',
            url: 'font/optimo/Plain-RegularIta.otf',
        },
        {
            guid: null,
            family: 'Optimo-Plain',
            format: 'truetype',
            color: 'black',
            weight: '700',
            style: 'normal',
            size: '14',
            url: 'font/optimo/Plain-Medium.ttf',
        },
        {
            guid: null,
            family: 'Optimo-Plain',
            format: 'truetype',
            color: 'black',
            weight: '700',
            style: 'italic',
            size: '14',
            url: 'font/optimo/Plain-MediumIta.ttf',
        },
        {
            guid: null,
            family: 'BB-Roller-Regular',
            format: 'truetype',
            color: 'black',
            weight: '400',
            style: 'normal',
            size: '14',
            url: 'font/bb-roller/BB-Roller-Mono-Regular-fontlab.ttf',
        },
        {
            guid: null,
            family: 'BB-Roller-Mono-semibold',
            format: 'truetype',
            color: 'black',
            weight: '600',
            style: 'normal',
            size: '14',
            url: 'font/bb-roller/BB-Roller-Mono-ProTx-semibold.otf',
        },
    ];
    const convertedCustomFontFaces = customFontFaces?.length
        ? customFontFaces.map((it) => {
            return {
                ...it,
                size: convertSizeToString(it.size),
                weight: convertFontWeightToString(it.weight),
                style: convertFontFaceStyleToString(it.style),
                format: convertFontFormatToString(it.format),
            };
        })
        : [];
    const defaultFontFacesWithCdnUrl = await Promise.all(defaultFontFaces.map(async (font) => {
        const url = await requestAssetUrl(font.url);
        if (!window.__isBlinkV2CdnEnabled) {
            if (window.location.protocol === 'file:') {
                const isAndroid = /android/i.test(navigator.userAgent);
                if (isAndroid) {
                    return {
                        ...font,
                        url: `file:///android_asset/web/${font.url}`,
                    };
                }
                const base = new URL('..', window.location.href);
                return {
                    ...font,
                    url: new URL(font.url, base).href,
                };
            }
            return {
                ...font,
                url: `${window.location.origin}/${font.url}`,
            };
        }
        return { ...font, url };
    }));
    const fontsWithUpdatedUrl = [
        ...convertedCustomFontFaces,
    ].map((it) => {
        return { ...it, url: `${window.location.origin}${it.url}` };
    });
    return [...defaultFontFacesWithCdnUrl, ...fontsWithUpdatedUrl];
};
//# sourceMappingURL=style-config.util.js.map